import { render } from "./transition-height.vue?vue&type=template&id=3bb2b000"
import script from "./transition-height.vue?vue&type=script&lang=js"
export * from "./transition-height.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__